<script>
    import ItemContainer from '../ItemContainer.svelte'
    export let items;
    export let pinnedItemIds;
    export let handleManageItemAction;
    export let handleFilterAction
    let finalItems;

    $: finalItems = items

    $: {
        items.sort((itemA, itemB) => {
            if (pinnedItemIds.includes(itemA.id)) {
                return -1;
            } else if (pinnedItemIds.includes(itemB.id)) {
                return 1;
            }
            return 0;
        })
        finalItems = items
    }
</script>

<main>
    {#each finalItems as item, index}
                            <ItemContainer
                                index={index}
                                item={item}
                                modalVisible={false}
                                filterAwaySource={undefined}
                                handleManageItemAction={handleManageItemAction}
                                handleFilterAction={handleFilterAction}
                            />
                        {/each}
</main>